import apiRequestType from "../apiRequestType";
import { apiConstants } from "../../utils/apiConstants";
import { apiTypes } from "../../utils/apiTypes";

const getUserClassAssignment = (
  classId,
  pageNum,
  pageSize,
  fromDate,
  toDate,
  userId,
  type
) => {
  return apiRequestType(
    apiTypes.GET,
    apiConstants.DISTRIBUTE.GET_USER_CLASS_ASSIGNMENT(
      classId,
      pageNum,
      pageSize,
      fromDate,
      toDate,
      userId,
      type
    )
  );
};

export default getUserClassAssignment;
